import { Injectable, NgZone } from '@angular/core';
import { Node } from "../services/node";
// import { auth } from 'firebase/compat/app';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';



export interface Item { name: string; }
@Injectable({
  providedIn: 'root'
})
export class TreeNodeService {

  private nodeDoc: AngularFirestoreDocument<Node>;
  node: Observable<Node>;

  private itemDoc: AngularFirestoreDocument;
  item

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {
    
  }

  // Sign in with email/password
  SaveData(data, orderID) {
    
    this.itemDoc = this.afs.doc(`Treedata/${orderID}`);
      this.item = this.itemDoc.valueChanges();
      return this.itemDoc.set(data)
        .then(async (result) => {
          
          this.ngZone.run(() => {
            // 
          });
        }).catch((error) => {
          window.alert(error.message)
        })
  }


  dateString(data) {
    let obj = {};
    Object.keys(data).forEach(key => {
      data[key]['url'] = Math.floor(Math.random() * Math.floor(12));
      let temp;
      if (data[key].birth) {
        if (data[key].birth['dateRange']) {
          let from, to
          if (data[key].birth['dateRange'].from) {
            if (data[key].birth['dateRange'].from.qualifier) {
              from = (data[key].birth['dateRange'].from.year ? data[key].birth['dateRange'].from.year : "-") + (data[key].birth['dateRange'].from.qualifier ? "." + data[key].birth['dateRange'].from.qualifier : "-");
            }
            else {
              from = (data[key].birth['dateRange'].from.year ? data[key].birth['dateRange'].from.year : "-") + (data[key].birth['dateRange'].from.month ? "." + data[key].birth['dateRange'].from.month : ".-") + (data[key].birth['dateRange'].from.day ? "." + data[key].birth['dateRange'].from.day : ".-");
            }
          }
          else {
            from = "-.-.-";
          }
          if (data[key].birth['dateRange'].to) {
            if (data[key].birth['dateRange'].to.qualifier) {
              to = (data[key].birth['dateRange'].to.year ? data[key].birth['dateRange'].to.year : "-") + (data[key].birth['dateRange'].to.qualifier ? "." + data[key].birth['dateRange'].to.qualifier : "-");
            }
            else {
              to = (data[key].birth['dateRange'].to.year ? data[key].birth['dateRange'].to.year : "-") + (data[key].birth['dateRange'].to.month ? "." + data[key].birth['dateRange'].to.month : ".-") + (data[key].birth['dateRange'].to.day ? "." + data[key].birth['dateRange'].to.day : ".-");
            }
          }
          else {
            to = "-.-.-";
          }
          temp = from + " - " + to;
        }
        if (data[key].birth['date']) {
          if (data[key].birth['date'].qualifier) {
            temp = (data[key].birth['date'].year ? data[key].birth['date'].year : "-") + (data[key].birth['date'].qualifier ? "." + data[key].birth['date'].qualifier : "-");
          }
          else {
            temp = (data[key].birth['date'].year ? data[key].birth['date'].year : "-") + (data[key].birth['date'].month ? "." + data[key].birth['date'].month : ".-") + (data[key].birth['date'].day ? "." + data[key].birth['date'].day : ".-");
          }
        }
      }
      else {
        temp = "-.-.-";
      }
      data[key]['birthday'] = temp

      if (data[key].death) {
        if (data[key].death['dateRange']) {
          let from, to
          if (data[key].death['dateRange'].from) {
            if (data[key].death['dateRange'].from.qualifier) {
              from = (data[key].death['dateRange'].from.year ? data[key].death['dateRange'].from.year : "-") + (data[key].death['dateRange'].from.qualifier ? "." + data[key].death['dateRange'].from.qualifier : "-");
            }
            else {
              from = (data[key].death['dateRange'].from.year ? data[key].death['dateRange'].from.year : "-") + (data[key].death['dateRange'].from.month ? "." + data[key].death['dateRange'].from.month : ".-") + (data[key].death['dateRange'].from.day ? "." + data[key].death['dateRange'].from.day : ".-");
            }
          }
          else {
            from = "-.-.-";
          }
          if (data[key].death['dateRange'].to) {
            if (data[key].death['dateRange'].to.qualifier) {
              to = (data[key].death['dateRange'].to.year ? data[key].death['dateRange'].to.year : "-") + (data[key].death['dateRange'].to.qualifier ? "." + data[key].death['dateRange'].to.qualifier : "-");
            }
            else {
              to = (data[key].death['dateRange'].to.year ? data[key].death['dateRange'].to.year : "-") + (data[key].death['dateRange'].to.month ? "." + data[key].death['dateRange'].to.month : ".-") + (data[key].death['dateRange'].to.day ? "." + data[key].death['dateRange'].to.day : ".-");
            }
          }
          else {
            to = "-.-.-";
          }
          temp = from + " - " + to;
        }
        if (data[key].death['date']) {
          if (data[key].death['date'].qualifier) {
            temp = (data[key].death['date'].year ? data[key].death['date'].year : "-") + (data[key].death['date'].qualifier ? "." + data[key].death['date'].qualifier : "-");
          }
          else {
            temp = (data[key].death['date'].year ? data[key].death['date'].year : "-") + (data[key].death['date'].month ? "." + data[key].death['date'].month : ".-") + (data[key].death['date'].day ? "." + data[key].death['date'].day : ".-");
          }
        }
      }
      else {
        temp = "-.-.-";
      }
      data[key]['deathday'] = temp
      obj[key] = data[key];
    });
    return obj;

  }


}
